/* eslint-disable */

// ** Redux Imports
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { discount } from "../../../../api/Api";

export const getAllDiscount = createAsyncThunk(
  "appDiscount/getAllDiscount",
  async (query) => {
    try {
      return discount.getAll(query);
    } catch (error) {
      console.error(error);
    }
  }
);

export const getAllOwnerDiscount = createAsyncThunk(
  "appDiscount/getAllOwnerDiscount",
  async (query) => {
    try {
      return discount.getAllOwner(query);
    } catch (error) {
      console.error(error);
    }
  }
);

export const getAllCustomDiscount = createAsyncThunk(
  "appDiscount/getAllCustomDiscount",
  async (query) => {
    try {
      return discount.getAllCustom(query);
    } catch (error) {
      console.error(error);
    }
  }
);

export const getAllAgentDiscount = createAsyncThunk(
  "appDiscount/getAllAgentDiscount",
  async (query) => {
    try {
      return discount.getAllAgent(query);
    } catch (error) {
      console.error(error);
    }
  }
);

export const getDiscount = createAsyncThunk(
  "appDiscount/getDiscount",
  async (id) => {
    try {
      return discount.getDiscount(id);
    } catch (error) {
      console.error(error);
    }
  }
);

export const addDiscount = createAsyncThunk(
  "appDiscount/addDiscount",
  async (value) => {
    try {
      return discount.create(value);
    } catch (error) {
      console.error(error);
    }
  }
);

export const deleteDiscount = createAsyncThunk(
  "appDiscount/deleteDiscount",
  async (id) => {
    return discount.remove(id);
  }
);

export const editDiscount = createAsyncThunk(
  "appDiscount/editDiscount",
  async (values) => {
    return discount.editDiscount(values);
  }
);

export const appDiscountSlice = createSlice({
  name: "appDiscount",
  initialState: {
    discount: [],
    ownerDiscount: [],
    agentDiscount: [],
    customDiscount: [],
    ownerDiscountFetch: false,
    agentDiscountFetch: false,
    customDiscountFetch: false,
    discountFetch: false,
    metaData: {},
    ownerMetaData: {},
    agentMetaData: {},
    customMetaData: {},
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllDiscount.fulfilled, (state, action) => {
        state.discount = action.payload?.data?.data;
        state.discountFetch = true;
        state.metaData = action.payload?.data?.metaData;
      })
      .addCase(getAllOwnerDiscount.fulfilled, (state, action) => {
        state.ownerDiscount = action.payload?.data?.data;
        state.ownerDiscountFetch = true;
        state.ownerMetaData = action.payload?.data?.metaData;
      })
      .addCase(getAllCustomDiscount.fulfilled, (state, action) => {
        state.customDiscount = action.payload?.data?.data;
        state.customDiscountFetch = true;
        state.customMetaData = action.payload?.data?.metaData;
      })
      .addCase(getAllAgentDiscount.fulfilled, (state, action) => {
        state.agentDiscount = action.payload?.data?.data;
        state.agentDiscountFetch = true;
        state.agentMetaData = action.payload?.data?.metaData;
      });
  },
});

export default appDiscountSlice.reducer;
